/**
 * assetBadgesStore — count badges for the Asset Management sidebar.
 *   Staff : myAssets, pendingAcks
 *   Admin : maintenanceDue, unacknowledged
 * Mirrors bookingBadgesStore. Written by AssetBadgeSubscriber; read by the
 * menu provider's countSelectors (which return `value || null`).
 */

import { create } from 'zustand';

interface AssetBadgesState {
  myAssets: number;
  pendingAcks: number;
  maintenanceDue: number;
  unacknowledged: number;
  setFromMetrics: (m: Partial<Pick<AssetBadgesState, 'myAssets' | 'pendingAcks' | 'maintenanceDue' | 'unacknowledged'>>) => void;
  reset: () => void;
}

const EMPTY = { myAssets: 0, pendingAcks: 0, maintenanceDue: 0, unacknowledged: 0 };

export const useAssetBadgesStore = create<AssetBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) => set((s) => ({ ...s, ...m })),
  reset: () => set(EMPTY),
}));
